import React, { useEffect, useRef, useState } from "react";

import CsrfTokenWatcher from "Utils/CsrfTokenWatcher";
import { BasicLoading } from "ZeroRuby";

import Button from "Cobalt/Button";
import { Card } from "Cobalt/Card";
import { Grid, Row, Col } from "Common/Grid";

const ToastSsoAuthorization = () => {
  const [csrfToken, setCsrfToken] = useState<string | undefined>();
  const formRef = useRef<HTMLFormElement>(null);

  // When csrfToken becomes available and the form is rendered, submit it.
  useEffect(() => {
    if (csrfToken && formRef.current) {
      formRef.current.submit();
    }
  }, [csrfToken]);

  const handleTokenAvailable = (token: string) => {
    setCsrfToken(token); // render will happen, then useEffect submits
  };

  const omniauthUrl = `/omniauth/toast${location.search}`;
  return (
    <Grid componentClass={Card} mt={5} p={0} style={{ height: "500px" }}>
      <Row>
        <Col>
          <BasicLoading loadingText="Loading your benefits..." />

          {/* Render the form only when we have the token */}
          {csrfToken && (
            <form ref={formRef} action={omniauthUrl} method="post" style={{ visibility: "hidden" }}>
              <input type="hidden" name="authenticity_token" value={csrfToken} />
              {/* Button is optional now; kept for clarity */}
              <Button type="submit">Sign in with Toast</Button>
            </form>
          )}

          <CsrfTokenWatcher onTokenAvailable={handleTokenAvailable} />
        </Col>
      </Row>
    </Grid>
  );
};

export default ToastSsoAuthorization;
